<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container" @click.stop>

                    <div class="modal-content">

                        <header class="modal-header">
                            <slot name="header"></slot>
                        </header>

                        <section class="modal-body">
                            <slot name="text"></slot>
                        </section>

                        <footer  class="modal-footer">
                            <slot name="footer">
                                <button class="button--close" @click.prevent="$emit('close')">
                                    <svg fill="#000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.25 49.25"><path d="M30.28 24.62L48.62 6.24a2 2 0 0 0 0-2.83L45.83.62a2 2 0 0 0-2.83 0L24.62 18.96 6.24.62a2 2 0 0 0-2.83 0L.62 3.41a2 2 0 0 0 0 2.83l18.34 18.38L.62 43a2 2 0 0 0 0 2.83l2.79 2.79a2 2 0 0 0 2.83 0l18.38-18.34L43 48.62a2 2 0 0 0 2.83 0l2.79-2.79a2 2 0 0 0 0-2.83z"/></svg></button>
                            </slot>
                        </footer>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['model'],

        mounted() {
            document.addEventListener('keydown', this.escapeHandler);
        },

        methods: {
            escapeHandler(event){
                if (event.key === 'Escape') {
                    this.$emit('close');
                    document.removeEventListener('keydown', this.escapeHandler);
                }
            },
        }
    };
</script>
